import axios from "axios";
import { updatePasswordStart, updatePasswordSuccess, updatePasswordError } from "./reducer";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import { RootState } from "slices";
import {updatePassword as updatePasswordApi } from "helpers/backend_helper";
import { toast } from "react-toastify";

interface UpdatePasswordPayload {
    email: string;
    otp: string;
    newPassword: string;
}

export const updatePassword =
    (
        payload: UpdatePasswordPayload,
        navigate: any
    ): ThunkAction<void, RootState, unknown, Action<string>> =>
        async (dispatch: Dispatch) => {
            dispatch(updatePasswordStart());
            try {                
                const response: any = await updatePasswordApi(payload);
                if (response && response.data && response.data.success) {
                    dispatch(updatePasswordSuccess());
                    toast.success("Password has been updated successfully");
                    
                    // Redirect to a confirmation page if needed
                    navigate("/login");
                  }
                  else {
                    throw new Error("Failed to update password")
                    
                  }
            } catch (error: any){
                dispatch(updatePasswordError(error))
                toast.error("Failed to send password reset email");
            }
        }